export default from './confirmation';



// WEBPACK FOOTER //
// ./app/components/confirmation/index.js